module.exports = __webpack_public_path__ + "img/prodolz-2.b0bdc1ba.png";